<template>
  <transition name="el-zoom-in-center">
    <div class="bg-contain common-blue-contain">
      <div class="breadcrumb-tilte">{{ $t('DataRecord') }} > {{ $t('DataFlowrecord') }}</div>
      <!-- 页面业务逻辑抽取至组件，新旧版界面共享，同时使用git摘取此提交同步至私有化 -->
      <MobileData :userId="userId" />
    </div>
  </transition>
</template>
<script>
import MobileData from '@/views/log/mobile-data/MobileData.vue'
export default {
  // 实时监控》历史记录》组件弹窗传用户名
  props: {
    userId: {
      type: String,
    },
  },
  components: {
    MobileData,
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl';

.bg-contain .common-table-cnt:has(.total-flow) /deep/ .el-table {
  height: 600px !important;
}
</style>
